module.exports = __webpack_public_path__ + "static/media/stocking.7d2e1bdc.svg";